import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/agentInformation.js'), 'agentInformation.js')
  resolveStoreModules(require('../store/analysis.js'), 'analysis.js')
  resolveStoreModules(require('../store/app.js'), 'app.js')
  resolveStoreModules(require('../store/approval.js'), 'approval.js')
  resolveStoreModules(require('../store/assignStudent.js'), 'assignStudent.js')
  resolveStoreModules(require('../store/campusIntroduction.js'), 'campusIntroduction.js')
  resolveStoreModules(require('../store/carryForwardManage.js'), 'carryForwardManage.js')
  resolveStoreModules(require('../store/caseInfo.js'), 'caseInfo.js')
  resolveStoreModules(require('../store/certificate.js'), 'certificate.js')
  resolveStoreModules(require('../store/common.js'), 'common.js')
  resolveStoreModules(require('../store/communicate.js'), 'communicate.js')
  resolveStoreModules(require('../store/companyProfile.js'), 'companyProfile.js')
  resolveStoreModules(require('../store/contract.js'), 'contract.js')
  resolveStoreModules(require('../store/corporateCulture.js'), 'corporateCulture.js')
  resolveStoreModules(require('../store/courseclassif.js'), 'courseclassif.js')
  resolveStoreModules(require('../store/courselearning.js'), 'courselearning.js')
  resolveStoreModules(require('../store/customer.js'), 'customer.js')
  resolveStoreModules(require('../store/daily.js'), 'daily.js')
  resolveStoreModules(require('../store/dataShare.js'), 'dataShare.js')
  resolveStoreModules(require('../store/dictionary.js'), 'dictionary.js')
  resolveStoreModules(require('../store/educational.js'), 'educational.js')
  resolveStoreModules(require('../store/enrolment.js'), 'enrolment.js')
  resolveStoreModules(require('../store/failOrders.js'), 'failOrders.js')
  resolveStoreModules(require('../store/getArtSubject.js'), 'getArtSubject.js')
  resolveStoreModules(require('../store/getSubjectList.js'), 'getSubjectList.js')
  resolveStoreModules(require('../store/getters.js'), 'getters.js')
  resolveStoreModules(require('../store/gettersCommon.js'), 'gettersCommon.js')
  resolveStoreModules(require('../store/hmtServiceStep.js'), 'hmtServiceStep.js')
  resolveStoreModules(require('../store/informationPackage.js'), 'informationPackage.js')
  resolveStoreModules(require('../store/loginLog.js'), 'loginLog.js')
  resolveStoreModules(require('../store/manageDeposit.js'), 'manageDeposit.js')
  resolveStoreModules(require('../store/manageDepositX.js'), 'manageDepositX.js')
  resolveStoreModules(require('../store/manageMargin.js'), 'manageMargin.js')
  resolveStoreModules(require('../store/manageMarginX.js'), 'manageMarginX.js')
  resolveStoreModules(require('../store/managerService.js'), 'managerService.js')
  resolveStoreModules(require('../store/matchIntroduceNew.js'), 'matchIntroduceNew.js')
  resolveStoreModules(require('../store/menu.js'), 'menu.js')
  resolveStoreModules(require('../store/message.js'), 'message.js')
  resolveStoreModules(require('../store/noticeOnline.js'), 'noticeOnline.js')
  resolveStoreModules(require('../store/onlineOrders.js'), 'onlineOrders.js')
  resolveStoreModules(require('../store/onlineRefund.js'), 'onlineRefund.js')
  resolveStoreModules(require('../store/operLog.js'), 'operLog.js')
  resolveStoreModules(require('../store/org.js'), 'org.js')
  resolveStoreModules(require('../store/orgProductOffline.js'), 'orgProductOffline.js')
  resolveStoreModules(require('../store/padManage.js'), 'padManage.js')
  resolveStoreModules(require('../store/planning.js'), 'planning.js')
  resolveStoreModules(require('../store/product.js'), 'product.js')
  resolveStoreModules(require('../store/productChange.js'), 'productChange.js')
  resolveStoreModules(require('../store/productDiscount.js'), 'productDiscount.js')
  resolveStoreModules(require('../store/productManage.js'), 'productManage.js')
  resolveStoreModules(require('../store/productManagement.js'), 'productManagement.js')
  resolveStoreModules(require('../store/productOffline.js'), 'productOffline.js')
  resolveStoreModules(require('../store/qualityApplicationNew.js'), 'qualityApplicationNew.js')
  resolveStoreModules(require('../store/qualityCoverLetterNew.js'), 'qualityCoverLetterNew.js')
  resolveStoreModules(require('../store/qualityUniversity.js'), 'qualityUniversity.js')
  resolveStoreModules(require('../store/refund.js'), 'refund.js')
  resolveStoreModules(require('../store/report.js'), 'report.js')
  resolveStoreModules(require('../store/revenues.js'), 'revenues.js')
  resolveStoreModules(require('../store/role.js'), 'role.js')
  resolveStoreModules(require('../store/route.js'), 'route.js')
  resolveStoreModules(require('../store/salesOrder.js'), 'salesOrder.js')
  resolveStoreModules(require('../store/schoolVideo.js'), 'schoolVideo.js')
  resolveStoreModules(require('../store/selfService.js'), 'selfService.js')
  resolveStoreModules(require('../store/speciality.js'), 'speciality.js')
  resolveStoreModules(require('../store/stationNotification.js'), 'stationNotification.js')
  resolveStoreModules(require('../store/student.js'), 'student.js')
  resolveStoreModules(require('../store/tim.js'), 'tim.js')
  resolveStoreModules(require('../store/toolAnswer.js'), 'toolAnswer.js')
  resolveStoreModules(require('../store/touristOrders.js'), 'touristOrders.js')
  resolveStoreModules(require('../store/university.js'), 'university.js')
  resolveStoreModules(require('../store/updateSchemeNo.js'), 'updateSchemeNo.js')
  resolveStoreModules(require('../store/user.js'), 'user.js')
  resolveStoreModules(require('../store/video.js'), 'video.js')
  resolveStoreModules(require('../store/workflow.js'), 'workflow.js')
  resolveStoreModules(require('../store/workPlanMonth.js'), 'workPlanMonth.js')
  resolveStoreModules(require('../store/workPlanWeek.js'), 'workPlanWeek.js')
  resolveStoreModules(require('../store/workPlanYear.js'), 'workPlanYear.js')
  resolveStoreModules(require('../store/yunBindOffline/index.js'), 'yunBindOffline/index.js')
  resolveStoreModules(require('../store/yunbind/index.js'), 'yunbind/index.js')
  resolveStoreModules(require('../store/serviceConditions/index.js'), 'serviceConditions/index.js')
  resolveStoreModules(require('../store/selfService/index.js'), 'selfService/index.js')
  resolveStoreModules(require('../store/reconcilation/index.js'), 'reconcilation/index.js')
  resolveStoreModules(require('../store/professionalGroup/index.js'), 'professionalGroup/index.js')
  resolveStoreModules(require('../store/opportunities-plan/index.js'), 'opportunities-plan/index.js')
  resolveStoreModules(require('../store/libraryManage/index.js'), 'libraryManage/index.js')
  resolveStoreModules(require('../store/inventory/index.js'), 'inventory/index.js')
  resolveStoreModules(require('../store/feedback/index.js'), 'feedback/index.js')
  resolveStoreModules(require('../store/artExamination/academic.js'), 'artExamination/academic.js')
  resolveStoreModules(require('../store/artExamination/artExamination.js'), 'artExamination/artExamination.js')
  resolveStoreModules(require('../store/artExamination/artOccupation.js'), 'artExamination/artOccupation.js')
  resolveStoreModules(require('../store/artExamination/onePointOneLevelArt.js'), 'artExamination/onePointOneLevelArt.js')
  resolveStoreModules(require('../store/artExamination/policy.js'), 'artExamination/policy.js')
  resolveStoreModules(require('../store/artExamination/serviceSystemArt.js'), 'artExamination/serviceSystemArt.js')
  resolveStoreModules(require('../store/artExamination/university.js'), 'artExamination/university.js')
  resolveStoreModules(require('../store/batch/batch.js'), 'batch/batch.js')
  resolveStoreModules(require('../store/campusPerformanceSummary/campusPerformanceSummary.js'), 'campusPerformanceSummary/campusPerformanceSummary.js')
  resolveStoreModules(require('../store/courseLearningProgress/courseLearningProgress.js'), 'courseLearningProgress/courseLearningProgress.js')
  resolveStoreModules(require('../store/customerStatistics/customerStatistics.js'), 'customerStatistics/customerStatistics.js')
  resolveStoreModules(require('../store/dailyWeekly/weekly.js'), 'dailyWeekly/weekly.js')
  resolveStoreModules(require('../store/evaluationReport/report2.js'), 'evaluationReport/report2.js')
  resolveStoreModules(require('../store/examination/bank.js'), 'examination/bank.js')
  resolveStoreModules(require('../store/examination/exam.js'), 'examination/exam.js')
  resolveStoreModules(require('../store/examination/paper.js'), 'examination/paper.js')
  resolveStoreModules(require('../store/examination/plan.js'), 'examination/plan.js')
  resolveStoreModules(require('../store/generalService/cityImports.js'), 'generalService/cityImports.js')
  resolveStoreModules(require('../store/generalService/disciplineCategory.js'), 'generalService/disciplineCategory.js')
  resolveStoreModules(require('../store/generalService/onePointOneLevel.js'), 'generalService/onePointOneLevel.js')
  resolveStoreModules(require('../store/generalService/subjectAssessDataManagementApi.js'), 'generalService/subjectAssessDataManagementApi.js')
  resolveStoreModules(require('../store/hmkColleges/hmkColleges.js'), 'hmkColleges/hmkColleges.js')
  resolveStoreModules(require('../store/hmkColleges/taiwanColleges.js'), 'hmkColleges/taiwanColleges.js')
  resolveStoreModules(require('../store/im/blacklist.js'), 'im/blacklist.js')
  resolveStoreModules(require('../store/im/conversation.js'), 'im/conversation.js')
  resolveStoreModules(require('../store/im/friend.js'), 'im/friend.js')
  resolveStoreModules(require('../store/im/group.js'), 'im/group.js')
  resolveStoreModules(require('../store/im/user.js'), 'im/user.js')
  resolveStoreModules(require('../store/lecturerApplication/lecturerApplication.js'), 'lecturerApplication/lecturerApplication.js')
  resolveStoreModules(require('../store/lecturerPerformanceRankingTable/lecturerPerformanceRankingTable.js'), 'lecturerPerformanceRankingTable/lecturerPerformanceRankingTable.js')
  resolveStoreModules(require('../store/manualReconciliation/manualReconciliation.js'), 'manualReconciliation/manualReconciliation.js')
  resolveStoreModules(require('../store/monthly/monthly.js'), 'monthly/monthly.js')
  resolveStoreModules(require('../store/new-regulation/estimatePlan.js'), 'new-regulation/estimatePlan.js')
  resolveStoreModules(require('../store/new-regulation/finalPlan.js'), 'new-regulation/finalPlan.js')
  resolveStoreModules(require('../store/new-regulation/initialPlan.js'), 'new-regulation/initialPlan.js')
  resolveStoreModules(require('../store/onePointOneLevel/onePointOneLevel.js'), 'onePointOneLevel/onePointOneLevel.js')
  resolveStoreModules(require('../store/operationalPerformanceRankingTable/operationalPerformanceRankingTable.js'), 'operationalPerformanceRankingTable/operationalPerformanceRankingTable.js')
  resolveStoreModules(require('../store/opportunityPoint/opportunity.js'), 'opportunityPoint/opportunity.js')
  resolveStoreModules(require('../store/quickReferenceTable/quickReferenceTable.js'), 'quickReferenceTable/quickReferenceTable.js')
  resolveStoreModules(require('../store/referenceScoreCalculate/referenceScoreCalculate.js'), 'referenceScoreCalculate/referenceScoreCalculate.js')
  resolveStoreModules(require('../store/relativeManagement/relativeManagement.js'), 'relativeManagement/relativeManagement.js')
  resolveStoreModules(require('../store/serviceSystem/baseDataManagement.js'), 'serviceSystem/baseDataManagement.js')
  resolveStoreModules(require('../store/serviceSystem/careerApi.js'), 'serviceSystem/careerApi.js')
  resolveStoreModules(require('../store/serviceSystem/learnMethodsApi.js'), 'serviceSystem/learnMethodsApi.js')
  resolveStoreModules(require('../store/serviceSystem/learnStatusApi.js'), 'serviceSystem/learnStatusApi.js')
  resolveStoreModules(require('../store/specialityinfoElective/specialityInfo.js'), 'specialityinfoElective/specialityInfo.js')
  resolveStoreModules(require('../store/supplementaryBaseScore/supplementaryBaseScore.js'), 'supplementaryBaseScore/supplementaryBaseScore.js')
  resolveStoreModules(require('../store/urbanCompetitiveness/urbanCompetitiveness.js'), 'urbanCompetitiveness/urbanCompetitiveness.js')
  resolveStoreModules(require('../store/versionManagement/versionManagement.js'), 'versionManagement/versionManagement.js')
  resolveStoreModules(require('../store/weekly/weekly.js'), 'weekly/weekly.js')
  resolveStoreModules(require('../store/newVersion/smartReport/index.js'), 'newVersion/smartReport/index.js')
  resolveStoreModules(require('../store/newVersion/initialPlan/index.js'), 'newVersion/initialPlan/index.js')
  resolveStoreModules(require('../store/newVersion/finalPlan/index.js'), 'newVersion/finalPlan/index.js')
  resolveStoreModules(require('../store/newVersion/estimatePlan/index.js'), 'newVersion/estimatePlan/index.js')
  resolveStoreModules(require('../store/generalProvinceArt/serviceStep/index.js'), 'generalProvinceArt/serviceStep/index.js')
  resolveStoreModules(require('../store/generalProvinceArt/initialPlan/index.js'), 'generalProvinceArt/initialPlan/index.js')
  resolveStoreModules(require('../store/generalProvinceArt/finalPlan/index.js'), 'generalProvinceArt/finalPlan/index.js')
  resolveStoreModules(require('../store/generalProvinceArt/estimatePlan/index.js'), 'generalProvinceArt/estimatePlan/index.js')
  resolveStoreModules(require('../store/generalProvince/studentList/index.js'), 'generalProvince/studentList/index.js')
  resolveStoreModules(require('../store/generalProvince/serviceStep/index.js'), 'generalProvince/serviceStep/index.js')
  resolveStoreModules(require('../store/generalProvince/occupationPlan/index.js'), 'generalProvince/occupationPlan/index.js')
  resolveStoreModules(require('../store/generalProvince/initialPlan/index.js'), 'generalProvince/initialPlan/index.js')
  resolveStoreModules(require('../store/generalProvince/finalPlan/index.js'), 'generalProvince/finalPlan/index.js')
  resolveStoreModules(require('../store/generalProvince/estimatePlan/index.js'), 'generalProvince/estimatePlan/index.js')
  resolveStoreModules(require('../store/aiReporting/timeAxis/index.js'), 'aiReporting/timeAxis/index.js')
  resolveStoreModules(require('../store/aiReporting/redemptionCode/index.js'), 'aiReporting/redemptionCode/index.js')
  resolveStoreModules(require('../store/aiReporting/policyInterpretation/index.js'), 'aiReporting/policyInterpretation/index.js')
  resolveStoreModules(require('../store/aiReporting/headQuarters/index.js'), 'aiReporting/headQuarters/index.js')
  resolveStoreModules(require('../store/aiReporting/gptfeedback/index.js'), 'aiReporting/gptfeedback/index.js')
  resolveStoreModules(require('../store/aiReporting/feedbackStatistics/index.js'), 'aiReporting/feedbackStatistics/index.js')
  resolveStoreModules(require('../store/aiReporting/creditCards/index.js'), 'aiReporting/creditCards/index.js')
  resolveStoreModules(require('../store/aiReporting/baseData/index.js'), 'aiReporting/baseData/index.js')
  resolveStoreModules(require('../store/aiReporting/appletProductShare/index.js'), 'aiReporting/appletProductShare/index.js')
  resolveStoreModules(require('../store/aiReporting/appletProduct/index.js'), 'aiReporting/appletProduct/index.js')
  resolveStoreModules(require('../store/aiReporting/aiOrder/index.js'), 'aiReporting/aiOrder/index.js')
  resolveStoreModules(require('../store/agentManage/searchCard/index.js'), 'agentManage/searchCard/index.js')
  resolveStoreModules(require('../store/agentManage/revenueBreakdownQuery/index.js'), 'agentManage/revenueBreakdownQuery/index.js')
  resolveStoreModules(require('../store/agentManage/productManage/index.js'), 'agentManage/productManage/index.js')
  resolveStoreModules(require('../store/agentManage/agentProfit/index.js'), 'agentManage/agentProfit/index.js')
  resolveStoreModules(require('../store/agentManage/agentList/index.js'), 'agentManage/agentList/index.js')
  resolveStoreModules(require('../store/agentManage/agentCustomer/index.js'), 'agentManage/agentCustomer/index.js')
  resolveStoreModules(require('../store/agentManage/agentCardManage/index.js'), 'agentManage/agentCardManage/index.js')
  resolveStoreModules(require('../store/generalService/hotSpot/hotSpot.js'), 'generalService/hotSpot/hotSpot.js')
  resolveStoreModules(require('../store/serviceSystemArt/newVersion/smartReport/index.js'), 'serviceSystemArt/newVersion/smartReport/index.js')
  resolveStoreModules(require('../store/serviceSystemArt/newVersion/initialPlan/index.js'), 'serviceSystemArt/newVersion/initialPlan/index.js')
  resolveStoreModules(require('../store/serviceSystemArt/newVersion/finalPlan/index.js'), 'serviceSystemArt/newVersion/finalPlan/index.js')
  resolveStoreModules(require('../store/serviceSystemArt/newVersion/estimatePlan/index.js'), 'serviceSystemArt/newVersion/estimatePlan/index.js')
  resolveStoreModules(require('../store/serviceSystemArt/newRegulation/smartReport/index.js'), 'serviceSystemArt/newRegulation/smartReport/index.js')
  resolveStoreModules(require('../store/serviceSystemArt/newRegulation/initialPlan/index.js'), 'serviceSystemArt/newRegulation/initialPlan/index.js')
  resolveStoreModules(require('../store/serviceSystemArt/newRegulation/finalPlan/index.js'), 'serviceSystemArt/newRegulation/finalPlan/index.js')
  resolveStoreModules(require('../store/serviceSystemArt/newRegulation/estimatePlan/index.js'), 'serviceSystemArt/newRegulation/estimatePlan/index.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
